// Process YAML front matter
// Must be at the very start of document
// ---
// key: value
// title: My Document
// ---

import { load as yamlLoad } from 'js-yaml'
import type StateBlock from '../state-block'

export default function front_matter(
  state: StateBlock,
  startLine: number,
  endLine: number,
  silent: boolean,
): boolean {
  // Front matter must be at the very start of the document
  if (startLine !== 0) return false

  let pos = state.bMarks[startLine] + state.tShift[startLine]
  let max = state.eMarks[startLine]

  // Check for opening ---
  if (pos + 3 > max) return false

  const marker = state.src.slice(pos, pos + 3)
  if (marker !== '---') return false

  pos += 3

  // Opening --- must be on its own line
  const firstLine = state.src.slice(pos, max).trim()
  if (firstLine.length > 0) return false

  if (silent) return true

  let nextLine = startLine
  let haveEndMarker = false

  // Search for closing ---
  while (nextLine < endLine) {
    nextLine++
    if (nextLine >= endLine) break

    pos = state.bMarks[nextLine] + state.tShift[nextLine]
    max = state.eMarks[nextLine]

    // Check for closing ---
    const line = state.src.slice(pos, max).trim()
    if (line === '---') {
      haveEndMarker = true
      break
    }
  }

  // Front matter requires a closing marker
  if (!haveEndMarker) return false

  // Extract YAML content
  const content = state.getLines(startLine + 1, nextLine, 0, false)

  // Parse YAML content
  let parsed: unknown = null
  try {
    parsed = yamlLoad(content)
  } catch {
    // Invalid YAML - keep parsed as null
  }

  const token = state.push('front_matter', 'div', 0)
  token.content = content
  token.markup = '---'
  token.map = [startLine, nextLine + 1]
  token.meta = { type: 'yaml', data: parsed }
  token.hidden = true // Front matter is typically not rendered

  state.line = nextLine + 1

  return true
}
